import React from "react";
import { makeStyles } from "@material-ui/styles";
import PropTypes from 'prop-types';
import AuthAddForm from "./AuthAddForm";


const AuthAdd = (props) => {

  const {className, match, history, ...rest } = props;
  const classes = useStyles();


  return (
    <div className={classes.root}>
      <div className={classes.content}>
        <AuthAddForm history={history} />
      </div>
    </div>
  );
};


AuthAdd.propTypes = {
  history: PropTypes.object
};

export default AuthAdd;


const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
  content: {
    marginTop: theme.spacing(2),
  },
}));
